module.exports = __webpack_public_path__ + "static/img/footBanner.422ba04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footBanner.png
// module id = mECy
// module chunks = 1